import { render, staticRenderFns } from "./ConfirmButton.vue?vue&type=template&id=6f38de48"
import script from "./ConfirmButton.vue?vue&type=script&lang=ts"
export * from "./ConfirmButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports